import React, { useMemo } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import Contacts from "../Contacts/Contacts";

const emptyArray = [];
const contactsUuids = [];
export function EventContacts({ event, contactButton }) {
  const filter = useMemo(
    () => [
      {
        fields: ["event"],
        formats: [],
        isOr: false,
        offset: "0",
        offsetFrom: "fixed",
        offsetType: "positive",
        offsetUnit: "day",
        operator: "is",
        order: 0,
        thread: "CurrentThread",
        timeZone: "",
        timeZoneFrom: "fixed",
        valueId: "",
        values: [event.Uuid],
        valueType: "fixed",
      },
    ],
    [event.Uuid]
  );

  return (
    <Contacts
      filters={filter}
      fields={undefined}
      useSearchOptions={true}
      includeContacts={undefined}
      ignoreContacts={contactsUuids}
      ignoreSets={undefined}
      contactSet={undefined}
      contactSets={emptyArray}
      strictCriteria={undefined}
      doNotUseSets={undefined}
      contactButton={contactButton}
      notDraggable={undefined}
      onDrop={undefined}
      allContactsButton={undefined}
      isModal={undefined}
      showContactFields={undefined}
      setSelectedContacts={undefined}
    />
  );
}

export default function EventContactsSlider({ event }) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Button
        variant=""
        onClick={handleShow}
        className="fw-bold text-white badge bg-secondary"
      >
        List
      </Button>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "800px" }}
        size="xl"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Contacts Related to Event</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <EventContacts event={event} />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
